const koMessages = {
  /* 01.General */
   "main.name": "이름",
  "main.sentiment": "감정",
  "main.urgency": "긴급도",
  "main.language": "언어",
  "main.agent": "상담원",
  "main.property_name": "시설명",
  "main.booking_number": "예약 번호",
  "main.check_out": "체크아웃",
  "main.check_in": "체크인",
  "main.adults": "성인",
  "main.corporate_code": "기업 코드",
  "main.group_code": "그룹 코드",
  "main.promo_code": "프로모션 코드",
  "main.ai_response": "AI 응답",
  "main.template_response": "템플릿 응답",
  "main.converttoticket": "티켓으로 변환",
  "main.switch_property": "시설 변경",
  "main.Group_id": "그룹 ID",
  "main.integration_id": "통합 ID",
  "main.submit": "제출",
  "main.cancel": "취소",
    "main.select_template": "템플릿 선택",
  "main.rooms": "객실",
  "main.rates": "요금",

  //footer

  "footer.knowledge": "지식",
  "footer.home": "홈",
  "footer.help": "도움말",

  //ticket
  "ticket.thank_you": "양식을 제출해 주셔서 감사합니다",
  "ticket.ticket": "티켓",
  "ticket.details": "티켓 세부 정보를 설명하는 양식을 작성해 주세요.",
  "ticket.select_category": "카테고리 선택",
  "ticket.category": "카테고리",
  "ticket.title": "제목",
  "ticket.notes": "메모",
  "ticket.status": "상태",
  "ticket.assigned_to": "할당 대상",
  "ticket.submit_form": "양식 제출",


  "main.total": "총계",
  "main.pastetooutlook": "Outlook에 붙여넣기",
  "main.children": "어린이",
  "main.promocode": "프로모션/기업/그룹 코드",
  "main.exact_match_only": "정확히 일치하는 항목만",
  "main.search": "검색",
  "main.no_rate_match": "선택한 조건과 일치하는 요금이 없습니다. 검색 조건을 변경한 후 다시 시도하세요.",
  "main.translate_to": "번역 대상",
  "main.regenerate": "다시 생성",
  "main.copy_text": "텍스트 복사",
  "main.additional_instructions": "추가 지침",

  "faq.helpcenter": "도움말 센터",
  "faq.reply.email.sabre.question": "Aven Hospitality Concierge Email Automation을 사용하여 이메일에 어떻게 답장하나요?",
  "faq.reply.email.sabre.answer": "이메일을 열고 Aven Hospitality 추가 기능을 실행하세요. 미리 정의된 템플릿 사용, AI 응답 생성 또는 이메일을 티켓으로 변환하는 세 가지 옵션 중 선택할 수 있습니다.",

  "faq.rates.availability.question": "응답에 요금, 예약 가능 여부 및 객실 정보를 어떻게 추가하나요?",
  "faq.rates.availability.answer": "+ Rates 기능을 사용하여 날짜와 투숙객 수 같은 정보를 입력하면 Concierge가 정확한 요금과 예약 가능 정보를 추가합니다.",

  "faq.different.language.question": "이메일이 다른 언어로 작성된 경우 어떻게 해야 하나요?",
  "faq.different.language.answer": "Aven Hospitality Concierge를 사용하면 수신 이메일을 원하는 언어로 번역할 수 있습니다.",

  "faq.pin.addin.question": "Outlook에서 추가 기능을 항상 사용할 수 있도록 하려면 어떻게 하나요?",
  "faq.pin.addin.answer": "Outlook에서 Aven Hospitality Concierge 추가 기능을 고정하면 항상 표시됩니다.",

  "faq.knowledge.hub.question": "Knowledge Hub 검색 옵션이란 무엇인가요?",
  "faq.knowledge.hub.answer": "Knowledge Hub 검색을 통해 Outlook에서 숙소 관련 정보를 빠르게 찾을 수 있습니다.",

  "faq.reply.email.myma.question": "Myma를 사용하여 이메일에 어떻게 답장하나요?",
  "faq.reply.email.myma.answer": "이메일을 열고 Myma 추가 기능을 실행하세요. 템플릿 사용, AI 응답 생성 또는 티켓 변환이 가능합니다.",

  "faq.room.details.question": "응답에 객실 정보를 어떻게 추가하나요?",
  "faq.room.details.answer": "+ Rooms를 사용하여 객실 설명과 이미지를 추가할 수 있습니다.",

  "faq.myma.different.language.question": "이메일이 다른 언어인 경우 어떻게 해야 하나요?",
  "faq.myma.different.language.answer": "Myma를 사용하면 수신 이메일을 원하는 언어로 번역할 수 있습니다.",

  "faq.myma.pin.addin.question": "Outlook에서 추가 기능을 항상 사용할 수 있도록 하려면 어떻게 하나요?",
  "faq.myma.pin.addin.answer": "Outlook에서 Myma 추가 기능을 고정하면 이메일마다 자동으로 열립니다.",
};
export default koMessages;